export default "__VITE_ASSET__HLxa3PWt__"